import {LoanPayment} from "@/models/LoanPayment/LoanPayment";
import {LoanPayments} from "@/models/LoanPayment/LoanPayments";
import {LoanTransactions} from "@/models/LoanPayment/LoanTransactions";

export class Profile {
  /**
   * @param {number} id
   * @param {string} prefix
   * @param {string} name
   * @param {StpAccount|null} stpAccount
   * @param {LoanBankAccount|null} bankAccount
   * @param {LoanBankAccount[]} bankAccounts
   */
  constructor(id, name, prefix, stpAccount, bankAccount, bankAccounts) {
    this.id = id;
    this.name = name;
    this.prefix = prefix;
    this.stpAccount = stpAccount;
    this.payments = new LoanPayments();
    this.transactions = new LoanTransactions();
    this.bankAccount = bankAccount;
    this.bankAccounts = bankAccounts;
    this.items = [];
  }

  /**
   * @param {string} label
   * @param {string} text
   * @param {boolean|null} flag
   */
  addItem(label, text, flag) {
    this.items.push({
      label,
      text,
      flag
    })
  }

  /**
   * @param {LoanPayment} loanPayment
   */
  addPayment(loanPayment) {
    this.payments.add(loanPayment)
  }

  /**
   * @param {LoanTransaction} loanTransaction
   */
  addTransaction(loanTransaction) {
    this.transactions.add(loanTransaction)
  }

  /**
   * @returns {boolean}
   */
  isApplicant() {
    return this.prefix === "CID";
  }
}
